import { render } from "./MailingMailTemplateOverview.vue?vue&type=template&id=592c8481&scoped=true&ts=true"
import script from "./MailingMailTemplateOverview.vue?vue&type=script&lang=ts"
export * from "./MailingMailTemplateOverview.vue?vue&type=script&lang=ts"

import "./MailingMailTemplateOverview.vue?vue&type=style&index=0&id=592c8481&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592c8481"]])

export default __exports__